import { render, staticRenderFns } from "./CompanyBroadcastMessageForm.vue?vue&type=template&id=272deda5"
import script from "./CompanyBroadcastMessageForm.vue?vue&type=script&lang=js"
export * from "./CompanyBroadcastMessageForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports